import React from 'react'

import { Spinner } from 'reactstrap'

export const LoadingPage: React.FC = () => (
  <div className="text-center overlay">
    <Spinner color="dark" className="loader-centivo" />
  </div>
)
